<template>
  <b-tab title="Portal/Kiosk Access">
    <eoc-portal-access-card
      v-if="patientId == null || patientId == ''"
      :portalAccess="patientItem"
      :otherAccesses="[...portalAccesses, ...contactsItems]"
      @switchChange="handleSwitchAction"
    />

    <eoc-portal-access-card
      v-for="(access, index) in portalAccesses"
      :key="index"
      :portalAccess="access"
      :otherAccesses="[...(patientItem ? [patientItem] : []), ...contactsItems]"
      @switchChange="handleSwitchAction"
    />

    <eoc-portal-access-card
      v-for="(access, index) in contactsItems"
      :key="'C' + index"
      :portalAccess="access"
      :otherAccesses="[
        ...(patientItem ? [patientItem] : []),
        ...portalAccesses
      ]"
      @switchChange="handleSwitchAction"
    />
  </b-tab>
</template>

<script>
import EocPortalAccessCard from "./EocPortalAccessCard.vue";
import portalAccessServer from "../../../server/portalAccess";

export default {
  name: "EocPortalAccessTab",
  components: {
    EocPortalAccessCard
  },
  data() {
    return {
      portalAccesses: [],
      contactsItems: [],
      patientItem: {},
      accessItems: []
    };
  },
  props: {
    patientId: {
      type: String,
      default: ""
    },
    values: {
      type: Array,
      default: function() {
        return [];
      }
    },
    contacts: {
      type: Array,
      default: function() {
        return [];
      }
    },
    patient: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  mounted() {
    this.portalAccesses = this.values;
    this.fetchPortalAccesses();
  },
  methods: {
    async fetchPortalAccesses() {
      if (this.patientId == null || this.patientId == "") return;
      this.portalAccesses = await portalAccessServer.query(this.patientId);
      this.patientItem = {};
      this.emitUpdate();
    },
    handleSwitchAction(access = {}, hasEmail = true) {
      access.status = !hasEmail
        ? "Disabled"
        : access.status == "Enabled"
        ? "Disabled"
        : "Enabled";
      let elements = [];
      if (this.patientId == null || this.patientId == "") {
        elements = [
          ...this.portalAccesses,
          ...this.contactsItems,
          this.patientItem
        ];
      } else {
        elements = [...this.portalAccesses, ...this.contactsItems];
      }
      this.$emit("update:values", elements);
      this.accessItems = [...this.contactsItems];
    },
    emitUpdate() {
      this.$emit("update:values", this.portalAccesses);
    }
  },
  watch: {
    contacts() {
      this.contactsItems = this.contacts
        .filter(item => item.id === undefined)
        .map(item => ({
          name: item.name,
          ...(item.relationship && { relationship: item.relationship.name }),
          ...(item.email && { email: item.email }),
          ...(item.oldEmail && { oldEmail: item.oldEmail }),
          status: "Disabled"
        }));

      this.contactsItems.forEach(item => {
        const access = this.accessItems.find(
          acc => acc.email === item.oldEmail
        );
        if (access) {
          item.status = access.status;
        }
      });

      this.contacts.forEach(item => {
        if (item.id != undefined) {
          this.portalAccesses.forEach(access => {
            if (
              (item.oldEmail && item.oldEmail === access.email) ||
              (access.contactId && access.contactId == item.id)
            ) {
              access.name = item.name;
              access.relationship = item.relationship?.name;
              access.email = item.email;
            }
          });
        }
        item.oldEmail = item.email;
      });
      const newPortalAccesses = this.portalAccesses.filter(
        portalAccess =>
          this.contacts.findIndex(c => c.email == portalAccess.email) >= 0 ||
                    this.patient.email == portalAccess.email
      );
      this.portalAccesses = newPortalAccesses;
      this.handleSwitchAction();
          },
    patient() {
      if (this.patientId != null && this.patientId != "") {
        this.portalAccesses.forEach(access => {
          if (access.relationship === "Patient") {
            access.name = this.patient.name;
            access.email = this.patient.email;
          }
        });
        return;
      }
      this.patientItem = this.patient;
    }
  }
};
</script>

<style scoped>
button[disabled] {
  color: white !important;
}
</style>
